import React from 'react';
import './KPICard.css';

export interface KPICardProps {
  title: string;
  value: string | number;
  subtitle?: string;
  change?: number; // Percentage change from previous period
  icon?: React.ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  loading?: boolean;
  className?: string;
}

export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  subtitle,
  change,
  icon,
  trend,
  loading = false,
  className = ''
}) => {
  const getTrendClass = () => {
    if (!trend || !change) return '';

    if (trend === 'up') {
      return change > 0 ? 'trend-positive' : 'trend-negative';
    } else if (trend === 'down') {
      return change < 0 ? 'trend-positive' : 'trend-negative';
    }
    return 'trend-neutral';
  };

  const formatChange = (changeValue: number): string => {
    const sign = changeValue > 0 ? '+' : '';
    return `${sign}${changeValue.toFixed(1)}%`;
  };

  if (loading) {
    return (
      <div className={`kpi-card loading ${className}`}>
        <div className="kpi-card-header">
          <div className="kpi-title-skeleton"></div>
        </div>
        <div className="kpi-value-skeleton"></div>
      </div>
    );
  }

  return (
    <div className={`kpi-card ${className}`}>
      <div className="kpi-card-header">
        {icon && <div className="kpi-icon">{icon}</div>}
        <h3 className="kpi-title">{title}</h3>
      </div>

      <div className="kpi-value">{value}</div>

      {subtitle && <div className="kpi-subtitle">{subtitle}</div>}

      {change !== undefined && (
        <div className={`kpi-change ${getTrendClass()}`}>
          <span className="change-arrow">
            {change > 0 ? '↑' : change < 0 ? '↓' : '→'}
          </span>
          <span className="change-value">{formatChange(change)}</span>
          <span className="change-label">vs previous period</span>
        </div>
      )}
    </div>
  );
};

export default KPICard;
